import React, { useEffect, useState, useCallback } from "react";
import {
    makeStyles,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
    IconButton,
    ButtonGroup,
    Button,
    DialogActions,
    Badge,
    TextField,
    darken,
    MenuItem,
    FormControl,
    Select,
    InputLabel,
    Paper, 
    Fab,
} from "@material-ui/core";
import {
    DatePicker,
    MuiPickersUtilsProvider,
    TimePicker,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { connect, useDispatch, useSelector } from "react-redux";
import Feedback from "../../../atoms/Feedback";
import { useHistory } from "react-router-dom";
import { reviewTRF, getTRFs } from "../../../../actions/travelActions/travelRequestActions";
import { airlinesArray, travelAgencyArray } from "../../../../utils";
import { getCurrencies } from "../../../../actions/currencyActions";
import { uploadDocument } from "../../../../actions/vendorsActions";
import ItineraryModal from "./ItineraryModal";

const useStyles = makeStyles((theme) => ({
    title: {
        display: "block",
        fontSize: 16,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        fontWeight: "bold"
    },
    title2: {
        display: "block",
        fontSize: 14,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        fontWeight: "bold",
        marginBottom: 10,
    },
    appBar: {
        // position: "relative",
        zIndex: 9000,
    },
    container: {
        marginTop: theme.spacing(6),
        padding: theme.spacing(6),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
    paper: {
        padding: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
        marginBottom: 20,
        background: theme.palette.type === "light" ? darken("#fff", 0.03) : darken("#fff", 0.80),
    },
    paper1: {
        marginTop: 10,
        padding: 10,
        background: theme.palette.type === "light" ? darken("#fff", 0.05) : darken("#fff", 0.80),
    },
    option: {
        fontSize: 15,
        "& > span": {
            marginRight: 10,
            fontSize: 18,
        },
    },
    textField: {
        marginBottom: theme.spacing(3),
    },
    dialogContent: {
        paddingBottom: 30,
        [theme.breakpoints.down("sm")]: {
            padding: "8px 14px",
        },
    },
    tabPanel: {
        padding: 14,
    },
    divider: {
        marginBottom: 10,
    },
    divider2: {
        height: 28,
        margin: 4,
    },
    total: {
        marginTop: 40,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    warningInfo: {
        color: "#f5f5f5",
        background: "#f44336",
        padding: 20,
        marginBottom: 20,
        marginRight: 10,
        "& > *": {
            fontWeight: 900,
        },
    },
    form: {
        marginBottom: 20,
    },
    grid: {
        marginBottom: 20,
    },
    input: {
        border: "1px solid #bdbdbd",
        padding: theme.spacing(2),
        borderRadius: 3,
    },
    btnWrapper: {
        textAlign: "center",
    },
    saveBtn: {
        fontFamily: "Rubik",
        letterSpacing: 2.5,
        margin: "30px 0",
        padding: theme.spacing(2),
        width: 200,
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    saveBtn2: {
        fontFamily: "Rubik",
        letterSpacing: 2.5,
        margin: "30px 0",
        padding: theme.spacing(2),
        width: 200,
        background: "#388e3c",
        color: "#fff",
        "&:hover": {
            background: darken("#388e3c", 0.15),
            // color: "#fff",
        },
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
        "&:disabled": {
            background: "#ccc",
            color: "#333",
        },
        "&:disabled:hover": {
            background: "#cccccc",
        },
    },
    small: {
        display: "block",
        fontSize: 12,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        color: theme.palette.warning.main,
    },
}));

const INIT_STATE = {
    ticketType: "",
    flightNumber: "",
    departureDate: "",
    departureTime: "",
    arrivalDate: "",
    arrivalTime: "",
    cost:"",
    currency: "",
    penalty: "",
    travelName: "",
    travelDate: "",
    travelAgency: "",
    travelPhone: "",
    travelItinerary: [],
    travelContact: "",
    travelComment: "",
    travelTicketNo: "",
};

const INIT_ITINERARY = {
    itinerary: "",
}
  
const ReviewTravelRequest = ({ openReview, handleCloseReview, id }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const [theUrl, setTheUrl] = useState("");
    const [openDoc, setOpenDoc] = useState(false);

    const { error, loading } = useSelector((state) => state.travelRequests);
    const { currencies } = useSelector((state) => state.currency);
    const [newstate, setState] = useState(INIT_STATE);
    const [itinerary, setItinerary] = useState(INIT_ITINERARY);
    const [itineraryFile, setItineraryFile] = useState(undefined);

    const [departureTime, setDepartureTime] = useState(new Date());
    const [departureDate, setDepartureDate] = useState(new Date());
    const [arrivalTime, setArrivalTime] = useState(new Date());
    const [arrivalDate, setArrivalDate] = useState(new Date());
    const [travelDate, setTravelDate] = useState(new Date());
        

    const [feed, setFeed] = useState({
        loading: false,
        open: false,
        message: "",
        success: false,
    });

    useEffect(() => {
        if (error && error !== null) {
            setFeed((prev) => ({
                loading: false,
                open: !prev.open,
                message: error,
                success: false,
            }));
        }
    }, [error]);
    
    const handleChange = (e) => {
        e.persist();
        setState((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
    };

    const handleChangeDepartureDate = (val) => {
        setDepartureDate(val);
    };
    const handleChangeDepartureTime = (val) => {
        setDepartureTime(val);
    };
    const handleChangeArrivalDate = (val) => {
        setArrivalDate(val);
    };
    const handleChangeArrivalTime = (val) => {
        setArrivalTime(val);
    };
    const handleChangeTravelDate = (val) => {
        setTravelDate(val);
    };
    
    const currencyCallback = useCallback(() => {
        dispatch(getCurrencies())
    }, [dispatch]);

    useEffect(() => {
        currencyCallback();
    }, [currencyCallback]);

    React.useEffect(() => {
        if (departureDate !== "" && departureTime !== "" && arrivalDate !== "" && arrivalTime !== "") {
            setState((prev) => ({
                ...prev,
                departureDate: moment(departureDate._d).format('DD/MM/YYYY'),
                departureTime: moment(departureTime._d).format('h:mm a'),
                arrivalDate: moment(arrivalDate._d).format('DD/MM/YYYY'),
                arrivalTime: moment(arrivalTime._d).format('h:mm a'),
                travelDate: moment(travelDate._d).format('DD/MM/YYYY'),            
            }));
        }
    }, [departureDate, departureTime, arrivalDate, arrivalTime, travelDate]);

    const handleUploadItinerary = (e) => {
        const { files } = e.target;
        setItineraryFile(files[0]);
    };

    useEffect(() => {
        const upload = async () => {
            if (itineraryFile) {
                const formData = new FormData();
                formData.append("doc", itineraryFile);
                let url = await new Promise((resolve, reject) => {
                        resolve(dispatch(uploadDocument(formData)));
                });
                if (url) {
                    setItinerary({itinerary: url });
                    setItineraryFile(null);
                }
            }
        };
        upload();
    }, [itineraryFile, dispatch]);

    const handleAddItineraryArray = (itinerary) => {
        if (itinerary.itinerary !== "") {
            setState((prev) => ({
                ...prev,
                travelItinerary: prev.travelItinerary.concat([itinerary]),
            }));
            setItinerary(INIT_ITINERARY);
        }
    };

    const handleRemoveItineraryArray = (i) => {
        setState((prev) => ({
            ...prev,
            travelItinerary: prev.travelItinerary.filter(
                (_, index) => index !== i
            ),
        }));
    };

    const handleOpenDoc = (url) => {
        setTheUrl(null);
        if(url){
            setTheUrl(url);
            setOpenDoc(true);
        }
    };
    
    const handleCloseDoc = () => {
        setOpenDoc(false);
    };

    const handleSubmitReview = async () => {
        const data = {
            ...newstate,
            id,
        };
        const res = await new Promise((resolve, reject) => {
            resolve(dispatch(reviewTRF(data)));
        });    
        
        if (res.success) {
            setTimeout(() => {
                handleCloseReview();
            }, 1500);
            dispatch(getTRFs());
            setFeed((prev) => ({
                loading: false,
                open: !prev.open,
                message: "Travel Request Reviewed Successfully.",
                success: true,
            }));
            setTimeout(() => {
                history.push(`/travel/request/view/${res.data._id}`);
            }, 2000);
        }
    };

    const handleCloseFeed = () => {
        setFeed((prevState) => ({ ...prevState, open: false }));
    };

    const validCheck = () =>
        !newstate.flightNumber || 
        !newstate.cost || 
        !newstate.currency || 
        !newstate.airline || 
        !newstate.ticketType || 
        !newstate.departureDate || 
        !newstate.departureTime || 
        !newstate.arrivalDate || 
        !newstate.arrivalTime || 
        !newstate.travelName ||
        !newstate.travelDate ||
        !newstate.travelAgency ||
        !newstate.travelPhone || 
        !newstate.travelContact ||
        !newstate.travelComment ||
        !newstate.travelTicketNo ||
        (newstate.travelItinerary.length === 0);

    return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <div>
                {feed.success ? (
                    <Feedback
                        handleCloseFeed={handleCloseFeed}
                        open={feed.open}
                        severity="success"
                        message={feed.message}
                    />
                ) : (
                    <Feedback
                        handleCloseFeed={handleCloseFeed}
                        open={feed.open}
                        severity="error"
                        message={feed.message}
                    />
                )}

                <ItineraryModal {...{ openDoc, handleCloseDoc, docs: theUrl }} />

                <Dialog
                    open={openReview}
                    onClose={handleCloseReview}
                    aria-labelledby="form-dialog-title"
                    fullWidth={true}
                    maxWidth="md"
                >
                    <DialogTitle>
                        <Grid container justify="space-between" alignItems="center">
                            <Grid item>
                                <Typography variant="overline" className={classes.title}>
                                    Review Travel Request
                                </Typography>
                            </Grid>
                            <Grid item>
                                <IconButton onClick={handleCloseReview}>
                                    <CloseIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <DialogContent dividers>
                        <Typography variant="overline" className={classes.title2}>
                            DEPARTURE AND ARRIVAL 
                        </Typography>

                        <Paper variant="outlined" square className={classes.paper}>
                            <Grid container spacing={3} justify="center" alignItems="center">
                                <Grid item xs={12} md={6}>
                                    <Grid container spacing={3} justify="center" alignItems="center">
                                        <Grid item xs={12} md={6}>
                                            <DatePicker
                                                autoOk
                                                format="DD/MM/yyyy"
                                                views={["year", "month", "date"]}
                                                label="Departure Date"
                                                fullWidth
                                                inputVariant="outlined"
                                                value={departureDate}
                                                onChange={handleChangeDepartureDate}
                                                required
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TimePicker
                                                autoOk
                                                fullWidth
                                                inputVariant="outlined"
                                                label="Departure Time"
                                                value={departureTime}
                                                onChange={handleChangeDepartureTime}
                                                required
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Grid container spacing={3} justify="center" alignItems="center">
                                        <Grid item xs={12} md={6}>
                                            <DatePicker
                                                autoOk
                                                format="DD/MM/yyyy"
                                                views={["year", "month", "date"]}
                                                label="Arrival Date"
                                                fullWidth
                                                inputVariant="outlined"
                                                value={arrivalDate}
                                                onChange={handleChangeArrivalDate}
                                                required
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TimePicker
                                                autoOk
                                                fullWidth
                                                inputVariant="outlined"
                                                label="Arrival Time"
                                                value={arrivalTime}
                                                onChange={handleChangeArrivalTime}
                                                required
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth variant="outlined" required>
                                    <InputLabel id="airline">Airline</InputLabel>
                                    <Select
                                        labelId="airline"
                                        name="airline"
                                        inputProps={{
                                            id: "airline",
                                            name: "airline",
                                        }}
                                        onChange={handleChange}
                                        value={newstate.airline || ""}
                                    >
                                        <MenuItem value="" disabled>Select Airline</MenuItem>
                                        {(airlinesArray && airlinesArray.length > 0) &&
                                            airlinesArray.map((item, i) => (
                                            <MenuItem key={i} value={item.name}>
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth variant="outlined" required>
                                    <InputLabel id="ticketType">Ticket Type</InputLabel>
                                    <Select
                                        labelId="ticketType"
                                        name="ticketType"
                                        inputProps={{
                                            id: "ticketType",
                                            name: "ticketType",
                                        }}
                                        onChange={handleChange}
                                        value={newstate.ticketType || ""}
                                    >
                                        <MenuItem value="OneWay">One-way</MenuItem>
                                        <MenuItem value="Return">Round Trip (Return)</MenuItem>
                                        <MenuItem value="MultiCity">Multi City</MenuItem>
                                    </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="flightNumber"
                                        name="flightNumber"
                                        label="Flight Number"
                                        placeholder="Flight Number"
                                        value={newstate.flightNumber || ""}
                                        onChange={handleChange}
                                        variant="outlined"
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="cost"
                                        name="cost"
                                        label="Cost"
                                        placeholder="Cost"
                                        value={newstate.cost || ""}
                                        onChange={handleChange}
                                        variant="outlined"
                                        fullWidth
                                        required
                                        type="number"
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel id="currency">Currency</InputLabel>
                                        <Select
                                            labelId="currency"
                                            name="currency"
                                            inputProps={{
                                                id: "currency",
                                                name: "currency",
                                            }}
                                            value={newstate.currency || ""}
                                            onChange={handleChange}
                                        >
                                            <MenuItem disabled>Select Currency</MenuItem>
                                                {currencies && currencies.map((currency) => (
                                                    <MenuItem key={currency._id} value={currency.code}>
                                                        {currency.code}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="penalty"
                                        name="penalty"
                                        label="Penalty (if any)"
                                        placeholder="Penalty (if any)"
                                        value={newstate.penalty || ""}
                                        onChange={handleChange}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </Paper>

                        <Typography variant="overline" className={classes.title2}>
                            TRAVEL ARRANGEMENT 
                        </Typography>

                        <Paper variant="outlined" square className={classes.paper}>
                            <Grid container spacing={3} justify="center" alignItems="center">
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="travelName"
                                        name="travelName"
                                        label="Name"
                                        placeholder="Name"
                                        value={newstate.travelName || ""}
                                        onChange={handleChange}
                                        variant="outlined"
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <DatePicker
                                        autoOk
                                        format="DD/MM/yyyy"
                                        views={["year", "month", "date"]}
                                        label="Travel Date"
                                        fullWidth
                                        inputVariant="outlined"
                                        value={travelDate}
                                        onChange={handleChangeTravelDate}
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth variant="outlined" required>
                                    <InputLabel id="travelAgency">Travel Agency</InputLabel>
                                    <Select
                                        labelId="travelAgency"
                                        name="travelAgency"
                                        inputProps={{
                                            id: "travelAgency",
                                            name: "travelAgency",
                                        }}
                                        onChange={handleChange}
                                        value={newstate.travelAgency || ""}
                                    >
                                        <MenuItem value="" disabled>Select Travel Agency</MenuItem>
                                        {(travelAgencyArray && travelAgencyArray.length > 0) &&
                                            travelAgencyArray.map((item, i) => (
                                            <MenuItem key={i} value={item.name}>
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="travelPhone"
                                        name="travelPhone"
                                        label="Phone"
                                        placeholder="Phone"
                                        value={newstate.travelPhone || ""}
                                        onChange={handleChange}
                                        variant="outlined"
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="travelContact"
                                        name="travelContact"
                                        label="Contact"
                                        placeholder="Contact"
                                        value={newstate.travelContact || ""}
                                        onChange={handleChange}
                                        variant="outlined"
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="travelTicketNo"
                                        name="travelTicketNo"
                                        label="Ticket Number"
                                        placeholder="Ticket Number"
                                        value={newstate.travelTicketNo || ""}
                                        onChange={handleChange}
                                        variant="outlined"
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        id="travelComment"
                                        name="travelComment"
                                        label="Comment"
                                        placeholder="Comment"
                                        value={newstate.travelComment || ""}
                                        onChange={handleChange}
                                        variant="outlined"
                                        fullWidth
                                        required
                                        multiline
                                        rows={3}
                                    />
                                </Grid>
                            </Grid>
                        </Paper>

                        <Typography variant="overline" className={classes.title2}>
                            TRAVEL ITINERARY
                        </Typography>

                        <Paper variant="outlined" square className={classes.paper}>
                            <Typography variant="overline" className={classes.title2}>
                                --- Please attach the itinerary(s) for this request. <br />
                                --- You can add as many itinerary attachments as you have. <br />
                                --- Click the blue button when file has uploaded to add the file.
                            </Typography>
                            
                            <Grid container spacing={3} justify="center" alignItems="center">
                                <Grid item xs={12} md={11}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <input
                                            type="file"
                                            label="Invoice File"
                                            variant="outlined"
                                            accept="image/*,.pdf"
                                            id="file"
                                            defaultValue={newstate.travelItinerary || ""}
                                            className={classes.input}
                                            onChange={handleUploadItinerary}
                                            />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={1}>
                                    <Fab
                                        color="primary"
                                        disabled={(itinerary.itinerary === "")}
                                        onClick={() => handleAddItineraryArray(itinerary)}
                                        >
                                        <AddIcon />
                                    </Fab>
                                </Grid>
                            </Grid>

                            {newstate.travelItinerary && newstate.travelItinerary.map((item, i) => (
                                <Paper variant="outlined" square className={classes.paper1} key={i}>
                                    <Grid container spacing={1} justify="center" alignItems="center">
                                        <Grid item xs={12} md={11}>
                                            <IconButton
                                                disabled={item.itinerary === null}
                                                onClick={() => handleOpenDoc(item.itinerary)}
                                                >
                                                <Badge
                                                    color="secondary"
                                                    badgeContent={item.itinerary.length ? 1 : null}
                                                    >
                                                    <AttachFileIcon />
                                                </Badge>
                                            </IconButton>
                                        </Grid>
                                        <Grid item xs={12} md={1}>
                                            <label>&nbsp;</label>
                                            <Fab
                                                color="secondary"
                                                onClick={() => handleRemoveItineraryArray(i)}
                                                >
                                                <CloseIcon />
                                            </Fab>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            ))}
                        </Paper>
                    </DialogContent>
                    <DialogActions>
                        <Grid container justify="center">
                            <Grid item>
                                <ButtonGroup>
                                    <Button onClick={handleCloseReview} className={classes.saveBtn}>
                                        Close
                                    </Button>
                                    <Button
                                        className={classes.saveBtn2}
                                        disabled={loading || validCheck()}
                                        onClick={handleSubmitReview}
                                    >
                                        {loading ? "Loading..." : "Review"}
                                    </Button>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </Dialog>
            </div>
        </MuiPickersUtilsProvider>
    );
};

export default connect(null, { reviewTRF })(ReviewTravelRequest);
